<p-dialog
  modal="true"
  styleClass="atlas-dialog-s"
  position="top" [(visible)]="showDialog"
  [closable]="false"
>
  <ng-template pTemplate="header">{{ 'revenue.invoice-line-item-details.header' | translate | ucfirst }}</ng-template>
  <div class="mb-52" *ngFor="let lineItem of flattenedLineItems">
    <wl-invoice-line-item-details
      [lineItem]="lineItem"
      [isExpanded]="selectedLineItemId && lineItem.LineItemId === selectedLineItemId"
    ></wl-invoice-line-item-details>
  </div>
  <div class="mct-grid line-item-grid"  data-pendo="lineItemDetailSummary">
    <div>
      <label class="f-wb t-ar light-text">{{ 'revenue.invoice-line-item-details.total-cost' | translate | ucfirst }}</label>
      <div class="f-wb t-ar">{{ invoiceCalculations?.totalCost | atlasCurrency }}</div>
    </div>
    <div>
      <label class="f-wb t-ar light-text">{{ 'revenue.invoice-line-item-details.amount-paid' | translate | ucfirst }}</label>
      <div class="f-wb t-ar">{{ invoiceCalculations?.amountPaid | atlasCurrency }}</div>
    </div>
    <div>
      <label class="f-wb t-ar light-text">{{ 'revenue.invoice-line-item-details.balance' | translate | ucfirst }}</label>
      <div class="f-wb t-ar">{{ invoiceCalculations?.balance | atlasCurrency }}</div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="close()">
      <span>{{ 'common.close' | translate | uppercase }}</span>
    </button>
  </ng-template>
</p-dialog>
